import React from "react";
import classNames from "classnames";

import styles from "./ProgressBar.module.scss";

interface Props {
  dataQA: string;
  width: number;
  progress: number;
  theme?: "light" | "dark";
  className?: string;
}

const ProgressBar: React.FC<Props> = ({
  dataQA,
  width,
  progress,
  theme = "light",
  className,
}) => {
  return (
    <div
      data-qa={dataQA}
      style={{ width: `${width}px` }}
      className={classNames(styles.container, styles[theme], className)}
    >
      <div
        data-qa="progress-indicator"
        style={{ width: `${progress}%` }}
        className={styles.progressIndicator}
      ></div>
    </div>
  );
};

export default ProgressBar;
